var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M1.076 2.617A1 1 0 0 1 2 2h20a1 1 0 0 1 .707 1.707L16 10.414V21a1 1 0 0 1-1.555.832l-6-4A1 1 0 0 1 8 17v-6.586L1.293 3.707a1 1 0 0 1-.217-1.09z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }